import React from "react";
import { getAnimalByIdE } from "../../api/animalsApi";
import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import './details.css'

export const DetailsAnimalE = () => {
    const { id } = useParams();
    const [numero, setNumero] = useState('');
    const [nom, setNom] = useState('');
    const [dateNaissance, setDateNaissance] = useState('');
    const [poids, setPoids] = useState('');
    const [genre, setGenre] = useState('');
    const [phase, setPhase] = useState('');
    const [race, setRace] = useState('');
    const [statuss, setStatus] = useState('');

    useEffect(() => {
        getAnimalByIdE(id).then(data => {
            setNumero(data.numero);
            setNom(data.nom);
            setDateNaissance(data.date_naissance);
            setPoids(data.poids);
            setGenre(data.genre);
            setPhase(data.phase.titre);
            setRace(data.race.nom);
            setStatus(data.reproductions?.[0]?.status?.titre);
        });

    }, [id]);

    const qrRef = useRef();
    const qrValue = 'Numero: ' + numero + '\nNom: ' + nom + '\nGenre: ' + genre + '\nRace: ' + race + '\nPhase: ' + phase + '\nDate Naissance: ' + dateNaissance + '\nStatut : ' + statuss;
    const handlePrint = useReactToPrint({
        contentRef: qrRef,
        documentTitle: 'Roue de reproduction - Animal :' + numero + ' - ' + nom,
    });

    return (
        <div className="details-wrapper">
            <h1 className="details-title">Détails de l'animal</h1>

            <div className="details-card">
                <div className="details-row">
                    <span className="label">Numéro:</span> <span>{numero}</span>
                </div>
                <div className="details-row">
                    <span className="label">Nom:</span> <span>{nom}</span>
                </div>
                <div className="details-row">
                    <span className="label">Date de Naissance:</span> <span>{dateNaissance}</span>
                </div>
                <div className="details-row">
                    <span className="label">Poids:</span> <span>{poids} kg</span>
                </div>
                <div className="details-row">
                    <span className="label">Genre:</span> <span>{genre}</span>
                </div>
                <div className="details-row">
                    <span className="label">Phase:</span> <span>{phase}</span>
                </div>
                <div className="details-row">
                    <span className="label">Race:</span> <span>{race}</span>
                </div>
                <div ref={qrRef} className="qr-print-area">
                    <h2>Code QR de l'Animal :</h2><br />
                    <QRCode value={qrValue} size={150} />
                </div>
                <button onClick={handlePrint} className="print-btn" disabled={!qrRef.current}>
                    Imprimer le QR Code
                </button>
            </div>
        </div>
    );
}